module.exports = {"330421001":"魏塘街道","330421002":"罗星街道","330421003":"惠民街道","330421102":"大云镇","330421103":"西塘镇","330421105":"干窑镇","330421107":"陶庄镇","330421111":"姚庄镇","330421112":"天凝镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330421.json
// module id = 902
// module chunks = 0